// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3wtDl","cell":"ColumnAccessor_cell__1ogRY","firstCellAccent":"ColumnAccessor_firstCellAccent__24h2b"};